export default "__VITE_ASSET__B8t04De8__"